<template>
  <div class="faq-container">
    <div class="page-heading">Digital Guardian App FAQs</div>
    <FaqItem v-for="(faq, index) in faqList" :key="index" :question="faq.question" :answer="faq.answer" />
  </div>
</template>
  
  <script>
import FaqItem from "./FaqItem.vue";

export default {
  name: "DGAvatar",
  components: {
    FaqItem,
  },
  data() {
    return {
      faqList: [
        {
          question: "What is Digital Guardian?",
          answer:
            "Digital Guardian is a privacy-preserving parent-child app designed to provide a safer online environment for children. It allows parents to monitor and manage their child's online activities through a set of comprehensive features.",
        },
        {
          question: "How does Digital Guardian work?",
          answer:
            "<b>Parent Setup</b>:<br/>Parents begin by creating their own profile and setting up one for their child in the app.<br/><b>Child Setup</b>:<br/>Parents give their child a special code to log into the app. This lets the child use all the app's features while keeping them safe online.<br/><b>Privacy Assurance</b>:<br/>No messages or pictures from users are sent to our servers. Everything stays on the device, making sure it's very secure and private.",
        },
        {
          question: "What is the Smart Keyboard feature?",
          answer:
            "The Smart Keyboard is a unique tool provided by the app. It monitors what the child types and offers advice if it detects any hateful, profane, or privacy-sensitive content. This helps guide the child towards positive online communication.",
        },
        {
          question: "Can you explain the Kid’s Wellbeing feature?",
          answer:
            "Kid’s Wellbeing tracks the child’s phone usage, including daily screen time and steps taken. This feature promotes a healthy balance between screen time and physical activity, encouraging the child to be more active.",
        },
        {
          question: "What is the Nudity Detection feature?",
          answer:
            "The Nudity Detection feature monitors all photos on the child's device for any potentially explicit or revealing content. This helps ensure the child does not engage in inappropriate sharing of images online.",
        },
        {
          question: "What information can parents see?",
          answer:
            "Parents can check if their child is using the app and which features are active on their child's phone. This helps parents understand their child's digital activities without invading their privacy.",
        },
        {
          question: "Is my child's privacy protected?",
          answer:
            "We place a high priority on ensuring privacy. The application has been meticulously crafted with stringent security protocols in place to protect the data of both parents and children. No user-generated content is conveyed to our servers; instead, all processing occurs on the device itself, thereby ensuring the utmost level of security and privacy.",
        },
        {
          question: "Is Digital Guardian available on both iOS and Android?",
          answer: "Yes, Digital Guardian is available for both iOS and Android devices.",
        },
        {
          question: "How can I get support for the app?",
          answer:
            'If you have any questions, concerns, or need technical support, please reach out to our support team at <a href="support@privately.eu">support@privately.eu</a>',
        },

        // Add more FAQs here in the same format
      ],
      newlineCSS: "newlineStringStyle",
    };
  },
};
</script>
  
  <style scoped>
.faq-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.page-heading {
  text-align: center;
  font-size: 24px;
  margin-bottom: 20px;
  font-weight: bold;
}
.newlineStringStyle {
  white-space: pre-wrap;
}
</style>
  